import React from "react";
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Carousel.css";

const Carousel2 = () => {
  const PHONE = "+919318333680";

  return (
    <section className="rk-premium-carousel rk-carousel-alt">
      <Carousel
        fade
        interval={4500}
        pause="hover"
        className="rk-custom-carousel"
        indicators={true}
      >

        {/* =====================================================
            SLIDE 1
        ===================================================== */}
        <Carousel.Item>
          <div className="rk-carousel-slide">

            <img
              src={`${process.env.PUBLIC_URL}/img/slider2.jpeg`}
              className="rk-carousel-image"
              alt="RK Sofa Works Custom Sofa Service"
            />

            <div className="rk-carousel-overlay"></div>

            <div className="rk-carousel-caption">

              <div className="rk-caption-topline">
                <span></span>
                <small>RK SOFA WORKS</small>
              </div>

              <span className="rk-caption-number">
                01 / 02
              </span>

              <h1>
                Your Space.
                <br />
                Your Style.
                <br />
                <em>Your Sofa.</em>
              </h1>

              <p>
                Upgrade your living space with custom sofa
                designs, premium upholstery and comfortable
                finishes made around your requirements.
              </p>

              <div className="rk-caption-buttons">

                <a
                  href={`tel:${PHONE}`}
                  className="rk-carousel-primary"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Get a Quote</span>
                </a>

                <Link
                  to="/sofa_repair"
                  className="rk-carousel-secondary"
                >
                  <span>Explore Work</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>

              </div>

            </div>

            <div className="rk-carousel-side-label">
              <span>CUSTOM SOFAS</span>
              <span>MODERN DESIGN</span>
              <span>MADE FOR YOU</span>
            </div>

          </div>
        </Carousel.Item>


        {/* =====================================================
            SLIDE 2
        ===================================================== */}
        <Carousel.Item>
          <div className="rk-carousel-slide">

            <img
              src={`${process.env.PUBLIC_URL}/img/slider4.jpg`}
              className="rk-carousel-image"
              alt="RK Sofa Works Sofa Makeover"
            />

            <div className="rk-carousel-overlay"></div>

            <div className="rk-carousel-caption">

              <div className="rk-caption-topline">
                <span></span>
                <small>DETAILS THAT MATTER</small>
              </div>

              <span className="rk-caption-number">
                02 / 02
              </span>

              <h1>
                Renew the
                <br />
                Look.
                <br />
                <em>Restore the Comfort.</em>
              </h1>

              <p>
                Sofa makeover, re-upholstery, foam replacement
                and repair solutions designed to give your
                furniture a cleaner and longer-lasting finish.
              </p>

              <div className="rk-caption-buttons">

                <Link
                  to="/about"
                  className="rk-carousel-primary"
                >
                  <span>About Our Work</span>
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>

                <a
                  href={`tel:${PHONE}`}
                  className="rk-carousel-secondary"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Call RK</span>
                </a>

              </div>

            </div>

            <div className="rk-carousel-side-label">
              <span>RE-UPHOLSTERY</span>
              <span>FOAM REPLACEMENT</span>
              <span>SOFA MAKEOVER</span>
            </div>

          </div>
        </Carousel.Item>

      </Carousel>
    </section>
  );
};

export default Carousel2;